@if(!data){
<div><code>Loading...</code></div>
}
@else
{
<div class="mat-elevation-z8">
  <mat-table [dataSource]="data" matSort (matSortChange)="sortChange($event)">
    @for (column of columns(); track column) {
    @if(column.field){
    <ng-container [matColumnDef]="column.field">
      <!-- header -->
      @if(column.sortable){
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.label | translate }}</mat-header-cell>
      }
      @else{
      <mat-header-cell *matHeaderCellDef>{{ column.label | translate }}</mat-header-cell>
      }

      <!-- value -->
      @if( column.type === 'date'){
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{ column.label | translate }}: </b>
        }
        {{row[column.field] | date: column.format || 'MM/dd/yyyy'}}
      </mat-cell>
      }
      @else if( column.type === 'link'){
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{ column.label | translate }}: </b>
        }
        @if(column.link){
        <a [routerLink]="`/main/${column.link}/${row.clientId}/${row[column.field]}`">{{'buttons.edit' | translate}}</a>
        }
        @else if(!row.formPct){
        <a [routerLink]="`/main/client/summary/${row.clientId}`">{{row[column.field]}}</a>
        }
        @else {
        <a [routerLink]="`/main/form/${row.formPct}/${row.formId}/${row.clientId}/${row.visitId}/${row.isArchived==='1'? 'view': 'edit'}`">{{row[column.field]}}</a>
        }
      </mat-cell>
      }
      @else{
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{ column.label | translate }}: </b>
        }
        {{row[column.field]}}
      </mat-cell>
      }
    </ng-container>
    }
    }
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <div class="mat-mdc-row" *matNoDataRow><div class="mat-mdc-cell no-data-cell">No data</div></div>
  </mat-table>

</div>
}

<mat-paginator (page)="pageChanged($event)"
               [length]="paginatorOptions.length"
               [pageIndex]="paginatorOptions.pageIndex"
               [pageSizeOptions]="paginatorOptions.pageSizeOptions"
               showFirstLastButtons
               aria-label="Select page of elements">
</mat-paginator>
